"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _apexChartReact = _interopRequireDefault(require("@alphapoint/apex-chart-react"));
var _rxjs = require("rxjs");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _withCssVars = require("../Theme/withCssVars");
require("@alphapoint/apex-chart-react/lib/chart-style.css");
require("../../styles/components/TradeComponent.css");
require("./PriceChart.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var tradeComponentClasses = (0, _cssClassesHelper.getBEMClasses)('trade-component');
var priceChartComponentClasses = (0, _cssClassesHelper.getBEMClasses)('price-chart');
var PriceChartComponent = /*#__PURE__*/function (_React$Component) {
  function PriceChartComponent() {
    _classCallCheck(this, PriceChartComponent);
    return _callSuper(this, PriceChartComponent, arguments);
  }
  _inherits(PriceChartComponent, _React$Component);
  return _createClass(PriceChartComponent, [{
    key: "renderChart",
    value: function renderChart() {
      var t = this.props.t;
      var _this$props = this.props,
        chartData = _this$props.chartData,
        changeTickersInterval = _this$props.changeTickersInterval,
        locale = _this$props.locale;
      this.chartDataSubject = new _rxjs.BehaviorSubject(chartData);
      var chartConfig = {
        chartDataSubject: this.chartDataSubject,
        changeTickersInterval: changeTickersInterval,
        currency_character: '',
        locale: locale,
        time_intervals: this.getTimeIntervalsConfig(),
        price_history: this.getPriceHistoryConfig(),
        volume_history: this.getVolumeHistoryConfig(),
        range_selector: this.getRangeSelectorConfig(),
        date_format_months: [t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'), t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')]
      };
      this.chart = new _apexChartReact["default"]('apex-chart', chartConfig);
      this.chart.DrawChart();
    }
  }, {
    key: "getTimeIntervalsConfig",
    value: function getTimeIntervalsConfig() {
      return [{
        label: '5m',
        seconds: 300
      }, {
        label: '15m',
        seconds: 900
      }, {
        label: '30m',
        seconds: 1800
      }, {
        label: '1h',
        seconds: 3600
      }, {
        label: '1d',
        seconds: 86400
      }];
    }
  }, {
    key: "getPriceHistoryConfig",
    value: function getPriceHistoryConfig() {
      var t = this.props.t;
      var getCssVar = this.props.getCssVar;
      return {
        font_size: 10,
        font_face: getCssVar('font__typeface'),
        border_primary_color: getCssVar('chart__border-color-primary'),
        border_secondary_color: getCssVar('chart__border-color-secondary'),
        background_color: getCssVar('secondary__bg-color'),
        bullish_color: getCssVar('chart__bullish-color'),
        bearish_color: getCssVar('chart__bearish-color'),
        price_line_color: getCssVar('chart__price-line-color'),
        sma_line_color: getCssVar('chart__sma-line'),
        ema_line_color: getCssVar('chart__ema-line-color'),
        bollinger_band_upper_line_color: getCssVar('chart__bollinger-band-upper-color'),
        bollinger_band_lower_line_color: getCssVar('chart__bollinger-band-lower-color'),
        market_price_line_color: getCssVar('chart__market-price-line-color'),
        market_price_label_color: getCssVar('chart__market-price-label-color'),
        market_price_background_color: getCssVar('chart__market-price-bg-color'),
        x_label_color: getCssVar('font__color-secondary'),
        y_label_color: getCssVar('font__color-secondary'),
        info_height: 30,
        info_precision: this.props.precision,
        y_label_width: 30,
        y_label_precision: this.props.precision,
        x_label_height: 30,
        x_label_precision: this.props.precision,
        info_labels: [t('Price'), t('Open'), t('Close'), t('High'), t('Low'), t('Volume')],
        use_bg_grid_lines: true,
        grid_lines_dashed: false,
        grid_lines_color: getCssVar('table__row-separator-color')
      };
    }
  }, {
    key: "getVolumeHistoryConfig",
    value: function getVolumeHistoryConfig() {
      var getCssVar = this.props.getCssVar;
      return {
        font_size: 10,
        font_face: getCssVar('font__typeface'),
        border_primary_color: getCssVar('chart__border-color-primary'),
        border_secondary_color: getCssVar('chart__row-separator-color'),
        background_color: getCssVar('secondary__bg-color'),
        bullish_color: getCssVar('chart__volume-bullish-color'),
        bearish_color: getCssVar('chart__volume-bearish-color'),
        x_label_color: getCssVar('font__color-secondary'),
        y_label_color: getCssVar('font__color-secondary'),
        y_label_width: 30,
        y_label_precision: this.props.precision,
        x_label_height: 2,
        x_label_precision: this.props.precision
      };
    }
  }, {
    key: "getRangeSelectorConfig",
    value: function getRangeSelectorConfig() {
      var getCssVar = this.props.getCssVar;
      return {
        font_size: 10,
        font_face: getCssVar('font__typeface'),
        border_primary_color: getCssVar('chart__border-color-primary'),
        border_secondary_color: getCssVar('chart__row-separator-color'),
        background_color: getCssVar('secondary__bg-color'),
        market_price_line_color: getCssVar('font__typeface'),
        market_price_label_color: getCssVar('font__typeface'),
        price_line_color: getCssVar('chart__price-line-color'),
        range_selection_color: getCssVar('chart__range-selection-color'),
        x_label_color: getCssVar('font__color-secondary'),
        y_label_color: getCssVar('font__color-secondary'),
        y_label_width: 0,
        y_label_precision: this.props.precision,
        x_label_height: 22,
        x_label_precision: this.props.precision
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderChart();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.chartData !== this.props.chartData) {
        this.chartDataSubject.next(this.props.chartData);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.chart) {
        this.chart.DestroyChart();
        this.chart = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(tradeComponentClasses(), " ").concat(priceChartComponentClasses())
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "apex-chart",
        className: "".concat(priceChartComponentClasses('chart'))
      }));
    }
  }]);
}(_react["default"].Component);
PriceChartComponent.propTypes = {
  precision: _propTypes["default"].number,
  theme: _propTypes["default"].string.isRequired,
  getCssVar: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _withCssVars.withCssVars)((0, _reactI18next.withTranslation)('core')(PriceChartComponent));